import { Component, OnInit, ChangeDetectorRef } from '@angular/core';
import { Subsector } from '../../interfaces/subsector.interface';
import { SubsectorService } from "../../services/subsector";
import { ReactiveFormsModule, FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
//import { CustomerClass } from '../../models/customer.class';
import { CustomerService } from "../../services/customer";
import { Customer } from '../../interfaces/customer.interface';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-edit-customer',
  imports: [ReactiveFormsModule, DatePipe],
  templateUrl: './edit-customer.html',
  styleUrl: './edit-customer.css'
})
export class EditCustomerComponent implements OnInit  {

  subsectors: Subsector[] = [];
  myForm: FormGroup;
  submitted: boolean = false;
    loading = false;
    selectedCustomer: Customer = {} as Customer;

  constructor(private subsectorService: SubsectorService, 
              private cdr: ChangeDetectorRef,
              private customerService: CustomerService,
              private router: Router,
              private location: Location,
              private fb: FormBuilder) 
              {
                this.myForm = this.fb.group({
                  id: new FormControl(''),
                  customercode: new FormControl('',[Validators.maxLength(30)]),
                  customername: new FormControl('', [Validators.required, Validators.minLength(3), Validators.maxLength(100)]),
                  subsectorcode: new FormControl('', [Validators.required, Validators.maxLength(25)]),
                  origindate: new FormControl('0000-00-00',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  expirydate: new FormControl('0000-00-00',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]),
                  addressline1: new FormControl('', [Validators.required,Validators.minLength(3),Validators.maxLength(100)]),
                  addressline2: new FormControl('',[Validators.maxLength(100)]),
                  addresszip: new FormControl('',[Validators.required,Validators.maxLength(10)]),
                  phone: new FormControl('',[Validators.maxLength(25)]),
                  salesareacode: new FormControl('',[Validators.maxLength(100)]),
                  uploadSelected: new FormControl(true),
                  uploaded: new FormControl('0000-00-00',[Validators.pattern(/^\d{4}-\d{2}-\d{2}$/),Validators.maxLength(10)]) 
                }); 
              };

  async ngOnInit(): Promise<void> {

    if (typeof this.customerService.selectedCustomer === undefined || this.customerService.selectedCustomer.id === undefined)
        {
          this.router.navigateByUrl('customer'); ;
          return;
        }

    try 
      {
        this.subsectors = await this.subsectorService.getSubsector();
        this.cdr.detectChanges();
      } catch (error) {
        console.error('getsubsector',error);
      }

      this.selectedCustomer = this.customerService.selectedCustomer;
      //this.myForm.value.customercode = this.customerService.selectedCustomer.customercode;
      this.myForm.get('id')?.setValue(this.customerService.selectedCustomer.id);
      this.myForm.get('customercode')?.setValue(this.customerService.selectedCustomer.customercode);
      this.myForm.get('customername')?.setValue(this.customerService.selectedCustomer.customername);
      this.myForm.get('subsectorcode')?.setValue(this.customerService.selectedCustomer.subsectorcode);
      this.myForm.get('origindate')?.setValue(this.customerService.selectedCustomer.origindate);
      this.myForm.get('expirydate')?.setValue(this.customerService.selectedCustomer.expirydate);
      this.myForm.get('addressline1')?.setValue(this.customerService.selectedCustomer.addressline1);
      this.myForm.get('addressline2')?.setValue(this.customerService.selectedCustomer.addressline2);
      this.myForm.get('addresszip')?.setValue(this.customerService.selectedCustomer.addresszip);
      this.myForm.get('phone')?.setValue(this.customerService.selectedCustomer.phone);
      this.myForm.get('salesareacode')?.setValue(this.customerService.selectedCustomer.salesareacode);
      this.myForm.get('uploaded')?.setValue(this.customerService.selectedCustomer.uploaded);
      this.cdr.detectChanges();
  }

  async updateCustomer(): Promise<void> 
  {
      var id = this.myForm.value.id.trim();
      var customercode = this.myForm.value.customercode != null ? this.myForm.value.customercode.trim() : "";
      var customername = this.myForm.value.customername != null ? this.myForm.value.customername.trim() : "";
      var subsectorcode = this.myForm.value.subsectorcode != null ? this.myForm.value.subsectorcode.trim() : "";
      var origindate = this.myForm.value.origindate != null ? this.myForm.value.origindate.trim() : "";
      var expirydate = this.myForm.value.expirydate != null ? this.myForm.value.expirydate.trim() : "";
      var addressline1 = this.myForm.value.addressline1 != null ? this.myForm.value.addressline1.trim(): "";
      var addressline2 = this.myForm.value.addressline2 != null ? this.myForm.value.addressline2.trim() : "";
      var addresszip = this.myForm.value.addresszip != null ? this.myForm.value.addresszip.trim() : "";
      var phone = this.myForm.value.phone != null ? this.myForm.value.phone.trim() : "";
      var salesareacode = this.myForm.value.salesareacode != null ? this.myForm.value.salesareacode.trim() : "";
      var uploaded = this.myForm.value.uploaded != null ? this.myForm.value.uploaded.trim() : "0000-00-00";
      var uploadSelected = this.myForm.value.uploadSelected;

      //if (uploadSelected)
      //{
        uploaded = "0000-00-00";
      //}

      try
        {
          await this.customerService.updateCustomer(customercode,customername,subsectorcode,origindate,expirydate,addressline1,addressline2,addresszip,phone,salesareacode,uploaded,id);
          this.cdr.detectChanges();
          this.router.navigateByUrl('customer'); 
        } catch (error) {
          console.error('updatecustomer',error);
        }

 
  }

  get id() {
    return this.myForm.get('id');
  }
  get customercode() {
    return this.myForm.get('customercode');
  }
  get customername() {
    return this.myForm.get('customername');
  }
  get subsectorcode() {
    return this.myForm.get('subsectorcode');
  }
  get origindate() {
    return this.myForm.get('origindate');
  }
  get expirydate() {
    return this.myForm.get('expirydate');
  }
  get addressline1() {
    return this.myForm.get('addressline1');
  }
  get addressline2() {
    return this.myForm.get('addressline2');
  }
  get addresszip() {
    return this.myForm.get('addresszip');
  }
  get phone() {
    return this.myForm.get('phone');
  }  
  get salesareacode() {
    return this.myForm.get('salesareacode');
  }
   get uploaded() {
    return this.myForm.get('uploaded');
  }
  get uploadSelected() {
    return this.myForm.get('uploadedSelected');
  }
 

goBack(): void {
    //this.location.back();
    this.router.navigateByUrl('customer');
  }
}
